<template>
  <Popover class="relative">
    <PopoverButton
      class="inline-flex items-center rounded-full py-3 pl-5 pr-3 text-lg font-medium text-gray-100 outline-none duration-150 hover:bg-gray-100/10">
      <span>{{ title }}</span>
      <IconShare
        class="ml-4 h-6 w-6 text-gray-100 transition duration-150 ease-in-out"
        aria-hidden="true" />
    </PopoverButton>

    <Transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0">
      <PopoverPanel class="absolute right-0 z-10 mt-3 transform px-0">
        <div class="w-full rounded-3xl bg-white p-6 shadow-lg ring-1 ring-black ring-opacity-5 md:w-max">
          <div class="mb-4 flex justify-between">
            <h3 class="text-xl font-medium text-gray-600">
              {{ title }}
            </h3>
            <PopoverButton class="group">
              <span class="sr-only">Close</span><IconCloseLine class="h-8 w-8 duration-100 group-hover:opacity-50" />
            </PopoverButton>
          </div>
          <div class="flex flex-wrap gap-x-8 gap-y-4 md:gap-y-0">
            <div class="flex gap-x-3">
              <NuxtLink
                v-for="(link, i) in shareLinks"
                :key="i"
                class="group relative mx-1.5 box-border flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full border border-gray-400 bg-white text-gray-400 lg:mx-0"
                target="_blank"
                :to="link.url"
                @click="handleClick(link.label)">
                <span class="sr-only">{{ link.label }}</span>
                <component
                  :is="`Icon${link.icon}`"
                  class="h-5" />
                <span
                  class="bg-pink-blue absolute inset-[-1px] rounded-full opacity-0 mix-blend-lighten transition-opacity duration-200 group-hover:opacity-100" />
              </NuxtLink>
            </div>

            <BlogButtonCopy
              :url="url"
              type="light"
              @click="handleClick('Copy link share')" />
          </div>
        </div>
      </PopoverPanel>
    </Transition>
  </Popover>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import { useRuntimeConfig } from '#app'
  import { useNuxtApp } from '#imports'

  import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

  import getShareLinks from '~/utils/urls'

  type SharePopover = {
    title: string
  }
  defineProps<SharePopover>()

  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()
  const { $event } = useNuxtApp()

  const url = runtimeConfig.public.siteUrl + route.path
  const shareLinks = getShareLinks(url)

  function handleClick(linkLabel: string) {
    $event('Sharing', { props: { [linkLabel]: route.path } })
  }
</script>
